import { combineReducers } from 'redux'
import {
  example,
  getProjectName,
  saveProjectName,
  updateProjectName,
  projectProposal,
  schemaSidebar,
} from './reducers'

export default combineReducers({
  example,
  getProjectName,
  saveProjectName,
  updateProjectName,
  projectProposal,
  schemaSidebar,
})
